// Opciones de ordenamiento de part-search. El `value` de cada opcion es la clave
// de STORE_SEARCH_SORTS en store_search_helper.php de la API.
export const SORT_OPTIONS = [
  { value: "relevance", labelKey: "message.products_page.sort_relevance" },
  { value: "price_asc", labelKey: "message.products_page.sort_price_asc" },
  { value: "price_desc", labelKey: "message.products_page.sort_price_desc" },
  { value: "title_asc", labelKey: "message.products_page.sort_title_asc" },
  { value: "title_desc", labelKey: "message.products_page.sort_title_desc" }
];

export const DEFAULT_SORT = "relevance";

export const isSortOption = value =>
  SORT_OPTIONS.some(option => option.value === value);
